import './JiraIssueOptions.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import { Menu } from 'antd';
import React from 'react';
import { SonarText } from '@ui/text';
import { Else, If, Then } from 'react-if';
import { useAction, useCurrentCustomer } from '@hooks';

export interface JiraIssuesOptionsProps {
	hide: () => void;
	initiativeId: number;
	issueKey: string;
	isSynced?: boolean;
}

export const JiraIssuesOptions: React.FC<JiraIssuesOptionsProps> = ({ hide, initiativeId, issueKey, isSynced }) => {
	const unlinkIssue = useAction(integrationsActions.requestDeleteJiraInitiativesUnlinkIssue);
	const syncJira = useAction(integrationsActions.requestPostInitiativesSyncJiraIssue);
	const unsyncJira = useAction(integrationsActions.requestDeleteInitiativesSyncJiraIssue);
	const customer = useCurrentCustomer();

	const handleOnRemoveIssue = () => {
		unlinkIssue({
			customerId: customer.id,
			initiativeId,
			issueKey
		});
	};

	const handleOnTurnOnStatusSync = () => {
		syncJira({
			customerId: customer.id,
			initiativeId,
			issueKey
		});

		hide();
	};

	const handleOnTurnOffStatusSync = () => {
		unsyncJira({
			customerId: customer.id,
			initiativeId,
			issueKey
		});

		hide();
	};

	return (
		<Menu>
			<Menu.Item onClick={ handleOnRemoveIssue }>
				<SonarText className='option-text'>{ COPY_SPECIFIC.REMOVE_ISSUE }</SonarText>
			</Menu.Item>
			<If condition={ isSynced }>
				<Then>
					<Menu.Item onClick={ handleOnTurnOffStatusSync }>
						<SonarText className='option-text'>{ COPY_SPECIFIC.TURN_OFF_STATUS_SYNC }</SonarText>
					</Menu.Item>
				</Then>
				<Else>
					<Menu.Item onClick={ handleOnTurnOnStatusSync }>
						<SonarText className='option-text'>{ COPY_SPECIFIC.TURN_ON_STATUS_SYNC }</SonarText>
					</Menu.Item>
				</Else>
			</If>
		</Menu>
	);
};
